/* fa-variant-carry.js v2 — furnica/craft: przenosi wybrane opcje PRAWDZIWYCH wariantów Shopify
 * (np. Länge prowadnic) przez pigułki pseudo-wariantów related_* (linki między produktami).
 * Bez tego klik pigułki po cichu resetuje wybór do wariantu domyślnego → złe pozycje w koszyku.
 * v2: wizualne zaznaczenie robi już inline snippet w <head> (pre-paint, bez migotania);
 * ten plik dosyła zdarzenie `change` (Dawn aktualizuje cenę/SKU/hidden id) + obsługuje zapis przy kliku.
 * Wartości nieistniejącej na produkcie docelowym NIE wymusza (uczciwy default).
 */
(function () {
  var KEY = "fa-variant-carry";
  var TTL = 15 * 60 * 1000; // 15 min

  function optionName(text) {
    return (text || "").split(":")[0].replace(/\s+/g, " ").trim();
  }
  // porównanie wartości odporne na różnice formatu między produktami ("45 mm" vs "45mm")
  function normVal(v) {
    return (v || "").toLowerCase().replace(/\s+/g, "");
  }

  function currentSelections() {
    var out = {};
    var picker = document.querySelector("variant-selects, variant-radios");
    if (!picker) return out;
    picker.querySelectorAll("fieldset").forEach(function (fs) {
      var leg = fs.querySelector("legend");
      var checked = fs.querySelector('input[type="radio"]:checked');
      if (leg && checked) out[optionName(leg.textContent)] = checked.value;
    });
    picker.querySelectorAll("select").forEach(function (sel) {
      var wrap = sel.closest(".product-form__input") || sel.parentElement;
      var lab = wrap ? wrap.querySelector("label") : null;
      var name = optionName(lab ? lab.textContent : sel.getAttribute("name"));
      if (name) out[name] = sel.value;
    });
    return out;
  }

  // 1) klik pigułki related_* (grupy tekstowe + swatche kolorów) → zapamiętaj aktualny wybór
  document.addEventListener(
    "click",
    function (e) {
      if (!e.target || !e.target.closest) return;
      var a = e.target.closest(".product__variant-group a, .product__color-variations-list a");
      if (!a) return;
      var sel = currentSelections();
      if (!Object.keys(sel).length) return;
      try {
        sessionStorage.setItem(KEY, JSON.stringify({ t: Date.now(), sel: sel }));
      } catch (err) {}
    },
    true
  );

  // 2) na docelowej PDP dosłanie `change` — motyw przestawia hidden input[name=id]/cenę/SKU.
  //    Radio mogło już zostać zaznaczone pre-paint przez snippet w <head> (window.__faCarryPre[name]=value)
  //    — wtedy `checked` się zgadza, ale Dawn o niczym nie wie, więc change wysyłamy i tak.
  function restore() {
    var raw = null;
    try {
      raw = sessionStorage.getItem(KEY);
    } catch (err) {}
    if (!raw) return;
    var data;
    try {
      data = JSON.parse(raw);
    } catch (err) {
      return;
    }
    if (!data || !data.sel || Date.now() - (data.t || 0) > TTL) return;
    var pre = window.__faCarryPre || {};
    var picker = document.querySelector("variant-selects, variant-radios");
    if (!picker) return;
    Object.keys(data.sel).forEach(function (name) {
      var val = data.sel[name];
      picker.querySelectorAll("fieldset").forEach(function (fs) {
        var leg = fs.querySelector("legend");
        if (!leg || optionName(leg.textContent) !== name) return;
        var radios = fs.querySelectorAll('input[type="radio"]');
        for (var i = 0; i < radios.length; i++) {
          if (normVal(radios[i].value) === normVal(val)) {
            var wasUnchecked = !radios[i].checked;
            var preChecked = normVal(pre[name]) === normVal(val);
            if (wasUnchecked) radios[i].checked = true;
            if (wasUnchecked || preChecked) radios[i].dispatchEvent(new Event("change", { bubbles: true }));
            return;
          }
        }
      });
      picker.querySelectorAll("select").forEach(function (sel) {
        var wrap = sel.closest(".product-form__input") || sel.parentElement;
        var lab = wrap ? wrap.querySelector("label") : null;
        if (optionName(lab ? lab.textContent : sel.getAttribute("name")) !== name) return;
        var opt = Array.prototype.find.call(sel.options, function (o) {
          return normVal(o.value) === normVal(val);
        });
        if (opt && sel.value !== opt.value) {
          sel.value = opt.value;
          sel.dispatchEvent(new Event("change", { bubbles: true }));
        }
      });
    });
    // wpis zostaje (TTL) — klient może klikać kolejne pigułki łańcuchowo
  }

  // 3) bez „ramki": po naszym change Dawn przerenderowuje picker i programowo focusuje zaznaczone
  //    radio → przeglądarka rysuje :focus-visible (przy fizycznym kliku myszą by nie rysowała).
  //    Przez ~2,5 s po restore zdejmujemy taki focus, chyba że user sam zaczął klikać/pisać.
  var userActed = false;
  ["pointerdown", "keydown", "touchstart"].forEach(function (ev) {
    document.addEventListener(ev, function () { userActed = true; }, { capture: true, once: true });
  });
  function suppressFocusRing() {
    var until = Date.now() + 2500;
    document.addEventListener(
      "focusin",
      function onF(e) {
        if (Date.now() > until || userActed) { document.removeEventListener("focusin", onF, true); return; }
        var t = e.target;
        if (t && t.matches && t.matches('variant-selects input[type="radio"], variant-radios input[type="radio"]')) t.blur();
      },
      true
    );
    var ae = document.activeElement;
    if (!userActed && ae && ae.matches && ae.matches('variant-selects input[type="radio"], variant-radios input[type="radio"]')) ae.blur();
  }

  function restoreAndSmooth() {
    restore();
    suppressFocusRing();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", restoreAndSmooth);
  else restoreAndSmooth();
})();
